import { OrderItem } from 'api/order';

export const validateItemPortfolio = (item: OrderItem): void => {
  if (!item.portfolioId && item.portfolio?.childPortfolios?.length === 0) throw Error;
};
